import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { RightSidebar } from '../../../components/RightSidebar'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../stores/CurrentUserStore'
import { CreateSupplier, Supplier } from '@getgreenline/homi-shared'
import { FormError } from '../../../components/FormError'
import { Track } from '../../../Track'
import { BlazeButton } from '../../../components/CustomButtons/BlazeButton'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
  location?: any
  supplier: Supplier | null
  onHide: () => void
}

interface State {
  isSaving: boolean
  errorMessage?: string
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class CreateSupplierTab extends React.Component<Props, State> {
  supplier = new CreateSupplier()

  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
    }
  }

  componentDidMount() {
    if (this.props.supplier) {
      Object.assign(this.supplier, this.props.supplier)
    }
  }

  hide() {
    this.props.onHide()
  }

  save() {
    this.setState({
      isSaving: true,
      errorMessage: undefined,
    })

    if (this.supplier.id) {
      this.props
        .currentCompanyStore!.supplierStore!.updateSupplier(this.supplier)
        .then(() => {
          Track.track('dashboard:vendors_updated')
          this.hide()
        })
        .catch((error) => {
          this.setState({
            isSaving: false,
            errorMessage: error.response.data.message || 'There was an error editing this vendor',
          })
        })
    } else {
      this.props
        .currentCompanyStore!.supplierStore!.addSupplier(this.supplier)
        .then(() => {
          Track.track('dashboard:vendors_created')
          this.hide()
        })
        .catch((error) => {
          this.setState({
            isSaving: false,
            errorMessage: error.response.data.message || 'There was an error adding this vendor',
          })
        })
    }
  }

  render() {
    const supplier = this.supplier
    return (
      <RightSidebar onHide={() => this.hide()}>
        <h3>{this.supplier.id ? `Edit brand/vendor` : `Add a brand/vendor`}</h3>
        <br />

        <div className='form-group'>
          <label>Name</label>
          <input
            className='form-control'
            value={this.supplier.name}
            onChange={(e) => {
              this.supplier.setName(e.target.value)
            }}
          />
        </div>

        <div className='form-group'>
          <label>Description</label>
          <input
            className='form-control'
            value={supplier.description || ''}
            onChange={(e) => {
              this.supplier.setDescription(e.target.value)
            }}
          />
        </div>

        <div className='form-group'>
          <label>Email</label>
          <input
            className='form-control'
            value={supplier.email || ''}
            onChange={(e) => {
              this.supplier.setEmail(e.target.value)
            }}
          />
        </div>

        <div className='form-group'>
          <label>Phone</label>
          <input
            className='form-control'
            value={supplier.phone || ''}
            onChange={(e) => {
              this.supplier.setPhone(e.target.value)
            }}
          />
        </div>

        <div className='form-group'>
          <label>Address</label>
          <input
            className='form-control'
            value={supplier.address || ''}
            onChange={(e) => {
              this.supplier.setAddress(e.target.value)
            }}
          />
        </div>

        <br />

        <div>
          {this.state.isSaving ? (
            <BlazeButton
              buttonProps={{
                className: 'w-100',
                type: 'primary',
                size: 'large',
                disabled: true,
              }}
              titleProps={{
                title: 'Saving...',
              }}
            />
          ) : (
            <BlazeButton
              buttonProps={{
                className: 'w-100',
                type: 'primary',
                size: 'large',
                onClick: () => {
                  this.save()
                },
              }}
              titleProps={{
                title: 'Save',
              }}
            />
          )}
        </div>

        <br />
        <FormError message={this.state.errorMessage} />
      </RightSidebar>
    )
  }
}
